import React from 'react';
import { RendererProps } from '@tunz/data-tables';
import RouterLinkFormatter from './RouterLinkFormatter';
import { LinkProps } from './types';

export const WalletLink: React.FC<LinkProps> = ({ id }) => {
	const WalletLinkFormatter = RouterLinkFormatter(
		(value: string) => `/wallets?wallet=${value}`,
		'PlatformAPIService',
		'GET:/wallets/{walletId}/',
	);
	return <WalletLinkFormatter value={id} record={{ value: id }} />;
};

export const WalletLinkRenderer = ({ value, record }: RendererProps<string>): React.JSX.Element => {
	const LinkFormatter = RouterLinkFormatter(
		() => `/wallets?wallet=${value}`,
		'PlatformAPIService',
		'GET:/wallets/{walletId}/',
	);
	return (
		<span className="mx-2">
			<LinkFormatter value={value} record={record} />
		</span>
	);
};
